import { MapPin, Users, RefreshCw, MapPinned, Network, FileCheck, Globe2, Gauge } from "lucide-react";
import { Reveal, SectionTag } from "./Reveal";

const REASONS = [
  { icon: MapPin, title: "Local Market Access", text: "On-the-ground Nigerian market knowledge and supply relationships." },
  { icon: Users, title: "One Procurement Partner", text: "A single relationship instead of juggling suppliers yourself." },
  { icon: RefreshCw, title: "Recurring Supply Management", text: "Ongoing procurement cycles coordinated for you." },
  { icon: MapPinned, title: "Multi-Location Support", text: "Procurement across several sites under one arrangement." },
  { icon: Network, title: "Supplier Network", text: "Selected supply partners matched to each transaction." },
  { icon: FileCheck, title: "Less Administrative Work", text: "Documentation, comparison and coordination handled for you." },
  { icon: Globe2, title: "International Procurement Support", text: "Local procurement capability for companies operating in Nigeria." },
  { icon: Gauge, title: "Operational Focus", text: "Your team stays focused on operations, not fuel paperwork." },
];

export default function WhyAjemi() {
  return (
    <section id="why-ajemi" data-testid="why-ajemi-section" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <SectionTag number="09" label="Why Ajemi" />
          <h2 className="font-outfit text-3xl md:text-5xl font-extralight tracking-tight text-white max-w-2xl">
            Why businesses <span className="text-gold">procure with Ajemi.</span>
          </h2>
        </Reveal>
        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {REASONS.map((r, i) => (
            <Reveal key={r.title} delay={0.05 * i}>
              <div
                data-testid={`why-card-${r.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="group h-full glass-panel rounded-2xl p-7 hover:border-gold/30 transition-all duration-500 hover:-translate-y-1"
              >
                <r.icon className="w-6 h-6 text-gold/80 group-hover:text-gold transition-colors duration-300" strokeWidth={1.5} />
                <h3 className="font-outfit text-lg font-light text-white mt-5">{r.title}</h3>
                <p className="text-sm text-white/50 mt-2 leading-relaxed">{r.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <p
            data-testid="why-ajemi-closing"
            className="mt-20 font-outfit text-2xl md:text-4xl font-extralight tracking-tight text-white text-center max-w-4xl mx-auto leading-snug"
          >
            You focus on your operation.{" "}
            <span className="text-gold">We handle the procurement workload.</span>
          </p>
          <p className="mt-4 text-center text-white/45 text-sm md:text-base max-w-2xl mx-auto">
            We don&rsquo;t just help you find fuel. We help you manage the procurement problem
            behind it.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
